'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _linksoftAlbatros = require('linksoft-albatros');

var _pickBy2 = require('lodash/pickBy');

var _pickBy3 = _interopRequireDefault(_pickBy2);

var _localize = require('linksoft/utils/localize');

var _localize2 = _interopRequireDefault(_localize);

var _common = require('../../utils/common');

var _common2 = _interopRequireDefault(_common);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var autoTabIndex = 2000; // start index for automatic indexing

var AddToCart = function (_React$Component) {
    (0, _inherits3.default)(AddToCart, _React$Component);

    function AddToCart(props) {
        (0, _classCallCheck3.default)(this, AddToCart);

        var _this = (0, _possibleConstructorReturn3.default)(this, (AddToCart.__proto__ || (0, _getPrototypeOf2.default)(AddToCart)).call(this, props));

        _this.wasSubmitted = false;

        _this.actualInputWidth = function (amount) {
            if (amount) {
                return amount.length + 2 + 'ch';
            }
        };

        _this.getFormClass = function () {
            _this.formClass = _this.props.formClass || "";
            if (_this.props.customerId) {
                _this.formClass += ' customer_' + _this.props.customerId;
            }

            if (_this.props.hasChanged) {
                _this.formClass += " pending-change";
                if (_this.props.processing) {
                    _this.formClass += " loading";
                    _this.onProcessing(_this);
                }
            }
            return _this.formClass;
        };

        _this.handleChange = function (e) {
            (0, _linksoftAlbatros.numbersOnly)(e);
            if (e.target.value !== _this.props.displayAmount) {
                _this.onChange(e);
            }
        };

        _this.handleKeyPress = function (e) {
            // make it flex for big numbers
            e.currentTarget.style.width = e.currentTarget.value.length + 3 + 'ch';
            if (e.key === 'Enter') {
                e.preventDefault();
                _this.handleSubmit(e);
            }
        };

        _this.handleKeyPressAndSubmit = function (e) {
            if (e.key === 'Enter') {
                // perform submit
                _this.handleSubmit(e);
            }
        };

        _this.handleSubmit = function (e) {
            e.preventDefault();
            _this.hideMissingInCartRow(e);

            if (_this.props.hasChanged) {
                _this.onSubmit(e);
                _this.handleShowGreenBackground();
            }
        };

        _this.hideMissingInCartRow = function (e) {
            // only for missing in cart
            if (!e.target.closest('.cart-missing')) return;

            if (e.target.value && e.target.value !== '0') {
                var missingInCartRowId = _this.props.productId.toString();
                _common2.default.hideItemPlaceHolderByClass(e.target, missingInCartRowId);
            }
        };

        _this.handleShowGreenBackground = function () {
            var result = _this.getAddToCartClass();
            _this.setState({ showGreenBackground: result });
        };

        _this.tabIndex = autoTabIndex++;
        _this.inputId = 'addToCart_' + _this.tabIndex;
        _this.preorder = props.preorder || false;
        _this.onChange = props.onChange || function () {};
        _this.onSubmit = props.onSubmit || function () {};
        _this.onProcessing = props.onProcessing || function () {};
        _this.onProcessingComplete = props.onProcessingComplete || function () {};
        _this.canChangeCart = props.canChangeCart;
        _this.formClass = "";
        _this.showAddToCartButton = props.showAddToCartButton;

        _this.state = {
            showGreenBackground: props.displayAmount > 0 ? ' added-to-cart' : ''
        };
        return _this;
    }

    (0, _createClass3.default)(AddToCart, [{
        key: 'render',
        value: function render() {
            var _pickBy = (0, _pickBy3.default)(this.props),
                _pickBy$displayAmount = _pickBy.displayAmount,
                displayAmount = _pickBy$displayAmount === undefined ? '' : _pickBy$displayAmount,
                _pickBy$processing = _pickBy.processing,
                processing = _pickBy$processing === undefined ? false : _pickBy$processing,
                _pickBy$hasChanged = _pickBy.hasChanged,
                hasChanged = _pickBy$hasChanged === undefined ? false : _pickBy$hasChanged,
                _pickBy$canChangeCart = _pickBy.canChangeCart,
                canChangeCart = _pickBy$canChangeCart === undefined ? false : _pickBy$canChangeCart,
                _pickBy$productId = _pickBy.productId,
                productId = _pickBy$productId === undefined ? 0 : _pickBy$productId,
                _pickBy$changedProduc = _pickBy.changedProductId,
                changedProductId = _pickBy$changedProduc === undefined ? 0 : _pickBy$changedProduc,
                _pickBy$customerId = _pickBy.customerId,
                customerId = _pickBy$customerId === undefined ? null : _pickBy$customerId;

            var inputId = this.inputId;

            if (processing) {
                this.wasSubmitted = true;
            }

            if (!processing && !hasChanged && (this.wasSubmitted || changedProductId === productId)) {
                this.wasSubmitted = false;
                this.onProcessingComplete(this);
            }
            this.getFormClass();
            var css = this.preorder ? "btn btn-preorder" : "btn"; // for diff color .btn-blue change to .preorder-button

            return canChangeCart ? !this.showAddToCartButton ? _react2.default.createElement(
                'form',
                { className: this.formClass + this.state.showGreenBackground + this.getAddToCartClass(), onSubmit: this.handleSubmit },
                _react2.default.createElement('input', { id: inputId, className: 'input-nubmer form-control', type: 'text',
                    value: displayAmount || '', onChange: this.handleChange, onKeyPress: this.handleKeyPress,
                    tabIndex: this.tabIndex,
                    'data-ean': this.props.ean,
                    'data-product-id': this.props.productId,
                    placeholder: '0',
                    style: { width: this.actualInputWidth(displayAmount) } })
            ) : _react2.default.createElement(
                'form',
                { className: this.formClass, onSubmit: this.handleSubmit },
                _react2.default.createElement('input', { id: inputId, className: 'input-nubmer form-control', type: 'text',
                    value: displayAmount || '', onChange: this.handleChange,
                    onKeyPress: this.handleKeyPressAndSubmit,
                    tabIndex: this.tabIndex,
                    'data-ean': this.props.ean,
                    'data-product-id': this.props.productId,
                    placeholder: '0',
                    style: { width: this.actualInputWidth(displayAmount) } }),
                _react2.default.createElement(
                    'a',
                    { onClick: this.handleSubmit, className: css },
                    _react2.default.createElement(
                        'span',
                        null,
                        (0, _localize2.default)("App:InsertIntoCart")
                    ),
                    _react2.default.createElement('i', { className: 'icon-cart-white' })
                )
            ) : _react2.default.createElement(
                'form',
                { className: this.formClass + this.state.showGreenBackground },
                _react2.default.createElement(
                    'label',
                    { htmlFor: inputId },
                    (0, _localize2.default)("App:NumberOfPieces")
                ),
                _react2.default.createElement('input', { readOnly: true, className: 'input-nubmer form-control', type: 'text',
                    value: displayAmount || "",
                    tabIndex: '-1',
                    'data-ean': this.props.ean,
                    'data-product-id': this.props.productId,
                    style: { width: this.actualInputWidth(displayAmount) } }),
                _react2.default.createElement(
                    'a',
                    { className: css + " disabled" },
                    _react2.default.createElement('i', { className: 'icon-cart' }),
                    ' ',
                    _react2.default.createElement(
                        'span',
                        null,
                        (0, _localize2.default)("App:IntoCart")
                    )
                )
            );
        }
    }, {
        key: 'getAddToCartClass',
        value: function getAddToCartClass() {
            return this.props.addedToCart ? ' added-to-cart' : '';
        }
    }]);
    return AddToCart;
}(_react2.default.Component);

AddToCart.propTypes = {
    amount: _propTypes2.default.number,
    displayAmount: _propTypes2.default.string,
    productId: _propTypes2.default.number.isRequired,
    hasChanged: _propTypes2.default.bool.isRequired,
    processing: _propTypes2.default.bool.isRequired,
    canChangeCart: _propTypes2.default.bool.isRequired,
    changedProductId: _propTypes2.default.number,
    formClass: _propTypes2.default.string
};

exports.default = AddToCart;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/cart/components/add-to-cart.js
// module id = 396
// module chunks = 0 1